export default __webpack_public_path__ + "static/media/bg_login.3d3ac1e5.jpg";